import React from 'react';

const UISettingsContext = React.createContext(null);

export default UISettingsContext;

export const UISettingsContextProvider = UISettingsContext.Provider;
export const UISettingsContextConsumer = UISettingsContext.Consumer;
